import { render, staticRenderFns } from "./PrivateAreaIndex.vue?vue&type=template&id=2728aa97&scoped=true"
import script from "./PrivateAreaIndex.vue?vue&type=script&lang=js"
export * from "./PrivateAreaIndex.vue?vue&type=script&lang=js"
import style0 from "./PrivateAreaIndex.vue?vue&type=style&index=0&id=2728aa97&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728aa97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2728aa97')) {
      api.createRecord('2728aa97', component.options)
    } else {
      api.reload('2728aa97', component.options)
    }
    module.hot.accept("./PrivateAreaIndex.vue?vue&type=template&id=2728aa97&scoped=true", function () {
      api.rerender('2728aa97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/PrivateArea/PrivateAreaIndex.vue"
export default component.exports